// extracted by mini-css-extract-plugin
export default {"price":"I1-z","onSale":"J1-z","msrpLabelPrice":"K1-z","msrpLabel":"L1-z","originalPrice":"M1-z","percentOff":"N1-z"};